export default __webpack_public_path__ + "static/media/AJAY.e89b773a.jpeg";